<template>
  <div>
    <div align="left">
      <el-button type="primary" icon="el-icon-circle-plus" @click="showDialog" >车辆出厂</el-button>
    </div>


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="id"
        label="ID"
        width="50">
      </el-table-column>
      <el-table-column
        fixed
        prop="car_id"
        label="车牌号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="out_time"
        label="出厂时间"
        width="140">
      </el-table-column>

      <!--<el-table-column-->
        <!--prop="car_id"-->
        <!--label="车牌号"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="line"
        label="线路"
        width="100">
      </el-table-column>
      <el-table-column
        prop="driver"
        label="驾驶员"
        width="100">
      </el-table-column>
      <el-table-column
        prop="entourage"
        label="押运员"
        width="100">
      </el-table-column>
      <el-table-column
        prop="out_box"
        label="周转箱"
        width="80">
      </el-table-column>
      <el-table-column
        prop="out_sharps_box"
        label="利器盒"
        width="80">
      </el-table-column>
      <el-table-column
        prop="out_bag"
        label="塑料袋"
        width="80">
      </el-table-column>
      <el-table-column
        prop="out_mileage"
        label="出厂里程"
        width="80">
      </el-table-column>
      <el-table-column
        prop="creator"
        label="填表人(门卫)"
        width="100">
      </el-table-column>


      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="showCarIn(scope.$index, tableData)"
            size="mini" type="success" >
            车辆入厂
          </el-button>


          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="tableData[scope.$index].state&1==1?'danger':'success'" >-->
            <!--{{tableData[scope.$index].state&1==1?"停用":"启用"}}-->
          <!--</el-button>-->

        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <el-dialog title="车辆出厂记录" :visible.sync="dialogFormVisible">
    <el-form :model="form" align="left">
      <el-form-item label="车牌号" :label-width="formLabelWidth">
        <el-select v-model="form.car_id" filterable placeholder="请选择">
          <el-option
            v-for="item in car_id_options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线路" :label-width="formLabelWidth">
        <el-select v-model="form.line" filterable placeholder="请选择">
          <el-option
            v-for="item in line_options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出厂时间" :label-width="formLabelWidth">
        <el-time-picker
          v-model="form.out_time"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59'
          }"
          placeholder="出厂时间">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="驾驶员" :label-width="formLabelWidth">
        <el-select v-model="form.driver" filterable placeholder="请选择">
          <el-option
            v-for="item in driver_options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="押运员" :label-width="formLabelWidth">
        <el-select v-model="form.entourage" filterable placeholder="请选择">
          <el-option
            v-for="item in driver_options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="出厂公里数" :label-width="formLabelWidth">
        <el-input v-model="form.out_mileage" autocomplete="on" clearable></el-input>
      </el-form-item>
      <el-form-item label="周转箱" :label-width="formLabelWidth">
        <el-input v-model="form.out_box" autocomplete="off"  clearable></el-input>
      </el-form-item>
      <el-form-item label="利器盒" :label-width="formLabelWidth">
        <el-input v-model="form.out_sharps_box" autocomplete="off"  clearable></el-input>
      </el-form-item>
      <el-form-item label="塑料袋" :label-width="formLabelWidth">
        <el-input v-model="form.out_bag" autocomplete="off"  clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="carOut">创 建</el-button>
    </div>
  </el-dialog>
    <el-dialog title="车辆入厂记录" :visible.sync="carInFormVisible">
      <el-form :model="form" align="left">
        <el-form-item label="车牌号" :label-width="formLabelWidth">
          {{inForm.car_id}}
        </el-form-item>
        <el-form-item label="线路" :label-width="formLabelWidth">
          {{inForm.line}}
        </el-form-item>

        <el-form-item label="驾驶员" :label-width="formLabelWidth">
          {{inForm.driver}}
        </el-form-item>

        <el-form-item label="押运员" :label-width="formLabelWidth">
          {{inForm.entourage}}
        </el-form-item>
        <el-form-item label="进厂时间" :label-width="formLabelWidth">
          <el-time-picker
            v-model="inForm.in_time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
            placeholder="进厂时间">
          </el-time-picker>
        </el-form-item>

        <el-form-item label="进厂公里数" :label-width="formLabelWidth">
          <el-input v-model="inForm.in_mileage" autocomplete="on" clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="周转箱" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.in_box" autocomplete="off"  clearable></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="利器盒" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.in_sharps_box" autocomplete="off"  clearable></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="塑料袋" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.in_bag" autocomplete="off"  clearable></el-input>-->
        <!--</el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carInFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="carIn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      showDialog(e){
        this.form={
          car_id:'',
          line:'',
          driver:'',
          entourage:'',
          out_mileage:0,
          out_time:'',
          out_box:0,
          out_bag:0,
          out_sharps_box:0,
        };
        this.dialogFormVisible=true;
      },

      carOut(){
        console.log("CarOut:",this.form);

        if (this.form.car_id==""){
          this.$alert('请选择车牌号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.line==""){
          this.$alert('请选择线路', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.driver==""){
          this.$alert('请选择驾驶员', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.out_time==""){
          this.$alert('请选择出厂时间', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.out_mileage==""){
          this.$alert('请输入出厂里程数', '错误', {
            confirmButtonText: '确定'
          });
          return
        }

        let $this=this;
        window.ws.AddFunc("S2W_CarOutRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '车辆出厂登记成功',
              type: 'success'
            });
            $this.dialogFormVisible=false;
            window.ws.Call("W2S_CarOutList",$this.page,$this.pageSize);
          }

        });
        window.ws.Call("W2S_CarOut",this.form.car_id,this.form.line,this.form.driver,this.form.entourage,$this.dateFormat("YYYY-mm-dd HH:MM",this.form.out_time),
          parseInt(this.form.out_mileage),parseInt(this.form.out_box),parseInt(this.form.out_sharps_box),parseInt(this.form.out_bag))
      },
      showCarIn(index, rows) {
        console.log("showCarIn:",index);
        //显示入厂录入框
        this.inForm={
            car_id:rows[index].car_id,
            line:rows[index].line,
            driver:rows[index].driver,
            entourage:rows[index].entourage,
            in_mileage:0,
            in_time:'',
            in_box:0,
            in_bag:0,
            in_sharps_box:0,
        }
        this.carInFormVisible=true

      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },
      carIn(){
        console.log("CarIn:",this.inForm);
        if (this.form.in_time==""){
          this.$alert('请选择出厂时间', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.in_mileage==""){
          this.$alert('请输入出厂里程数', '错误', {
            confirmButtonText: '确定'
          });
          return
        }

        let $this=this;
        window.ws.AddFunc("S2W_CarInRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '车辆入厂登记成功',
              type: 'success'
            });
            $this.dialogFormVisible=false;
            window.ws.Call("W2S_CarOutList",$this.page,$this.pageSize);
          }

        });
        window.ws.Call("W2S_CarIn",this.inForm.car_id,$this.dateFormat("YYYY-mm-dd HH:MM",this.inForm.in_time),
          parseInt(this.inForm.in_mileage),parseInt(this.inForm.in_box),parseInt(this.inForm.in_sharps_box),parseInt(this.inForm.in_bag))
      },
      handleSizeChange(e){
        this.pageSize=e;
        window.ws.Call("W2S_CarOutList",this.page,this.pageSize);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_CarOutList",this.page,this.pageSize);
      }
    },
    mounted() {
      let $this=this;
      console.log("###Page loaded !");

      window.ws.AddFunc("S2W_CarAndLineAndDriverRes",function(code,err,cars,lines,drivers){
        if (code==coder.OK) {
          let carIDs = [];
          for(let i=0;i<cars.length;i++){
            carIDs.push({value:cars[i],label:cars[i]})
          }
          $this.car_id_options=carIDs;
          // $this.setData({car_id_options:carIDs});

          let lineArr = [];
          for(let i=0;i<lines.length;i++){
            lineArr.push({value:lines[i],label:lines[i]})
          }
          $this.line_options = lineArr;
          // $this.setData({line_options :lineArr});


          let driverArr = [];
          for(let i=0;i<drivers.length;i++){
            driverArr.push({value:drivers[i],label:drivers[i]})
          }
          $this.driver_options = driverArr
          // $this.setData({driver_options:driverArr});
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_CarAndLineAndDriver");

      window.ws.AddFunc("S2W_CarOutListRes",function (code,err,currentPage,total,list) {
        console.log("S2W_CarOutListRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_CarOutList",$this.page,$this.pageSize);
    },
    data() {
      return {
        form: {
          car_id:'',
          line:'',
          driver:'',
          entourage:'',
          out_mileage:0,
          out_time:'',
          out_box:0,
          out_bag:0,
          out_sharps_box:0,
        },
        inForm:{
          car_id:'',
          line:'',
          driver:'',
          entourage:'',
          in_mileage:0,
          in_time:'',
          in_box:0,
          in_bag:0,
          in_sharps_box:0,
        },
        car_id_options: [{
          value: '川A:12345',
          label: '川A:12345'
        }, {
          value: '川A:11111',
          label: '川A:11111'
        }, {
          value: '川A:22222',
          label: '川A:22222'
        }, {
          value: '川A:23456',
          label: '川A:23456'
        }, {
          value: '川A:34567',
          label: '川A:34567'
        }],
        car_id_value: '',

        line_options: [{
          value: '乐山',
          label: '乐山'
        }, {
          value: '夹江',
          label: '夹江'
        }, {
          value: '金口河',
          label: '金口河'
        }, {
          value: '峨眉山',
          label: '峨眉山'
        }, {
          value: '五通桥',
          label: '五通桥'
        }],
        line_value: '',

        driver_options: [{
          value: '张三',
          label: '张三'
        }, {
          value: '李四',
          label: '李四'
        }, {
          value: '王麻子',
          label: '王麻子'
        }, {
          value: '川建国',
          label: '川建国'
        }, {
          value: '路人甲',
          label: '路人甲'
        }],
        driver_value: '',
        entourage_value:'',
        dialogFormVisible:false,
        carInFormVisible:false,
        formLabelWidth: '120px',
        page:1,
        pageSize:10,
        total:0,
        tableData: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/outRec.vue